// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "js/" + ({"324":"scene","443":"about"}[chunkId] || chunkId) + "." + {"324":"b95604c5","443":"14e5bed0","530":"1ec48d45"}[chunkId] + ".js";
};